import { RequestState } from "vuex-fetch-factory";
import { InvoiceModel, AccessLogUserModel } from "../models";

export interface StateInterface {
  vuexFetchersState: Map<string, Map<string, RequestState>>;
  invoices: InvoiceModel[];
  accessLogs: AccessLogUserModel[];
}

const state: StateInterface = {
  vuexFetchersState: new Map(),
  invoices: [],
  accessLogs: []
};

export default state;
